import { toast } from "react-hot-toast";
import { actionType } from "../utils/helpers/generalHelper";
import * as CommunityConstants from "../constants/community.constant";
import CommunityService from "../services/community.service";
import ErrorHelper from "../utils/helpers/errorHelper";

export const fetchCommunities = (pageAble) => async (dispatch) => {
  try {
    dispatch(actionType(CommunityConstants.FETCH_ALL_COMMUNITY_REQUEST));
    const data = await CommunityService.fetchAll(pageAble);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(CommunityConstants.FETCH_ALL_COMMUNITY_SUCCESS, data.data)
    );
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CommunityConstants.FETCH_ALL_COMMUNITY_FAILURE));
    toast.error(message);
  }
};

export const fetchCommunity = (communityId) => async (dispatch) => {
  try {
    dispatch(actionType(CommunityConstants.FETCH_COMMUNITY_REQUEST));
    const data = await CommunityService.fetchById(communityId);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(CommunityConstants.FETCH_COMMUNITY_SUCCESS, data.data));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CommunityConstants.FETCH_COMMUNITY_FAILURE));
    toast.error(message);
  }
};

export const fetchCommunityMembers = (communityId) => async (dispatch) => {
  try {
    dispatch(actionType(CommunityConstants.FETCH_COMMUNITY_MEMBERS_REQUEST));
    const data = await CommunityService.fetchCommunityMembers(communityId);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(CommunityConstants.FETCH_COMMUNITY_MEMBERS_SUCCESS, data.data)
    );
  } catch (error) {
    let message =
      error !== undefined ? error.data.errors[0].message : "Server error";
    dispatch(actionType(CommunityConstants.FETCH_COMMUNITY_MEMBERS_FAILURE));
    toast.error(message);
  }
};

export const closeModal = () => async (dispatch) => {
  dispatch(actionType(CommunityConstants.CLOSE_COMMUNITY_MODAL_REQUEST));
};

export const createCommunity = (formData) => async (dispatch) => {
  try {
    dispatch(actionType(CommunityConstants.CREATE_COMMUNITY_REQUEST));
    const data = await CommunityService.create(formData);
    if (data === undefined || data.status !== 201) {
      throw data;
    }
    dispatch(actionType(CommunityConstants.CREATE_COMMUNITY_SUCCESS));
    dispatch(fetchCommunities());
    // navigate();
  } catch (error) {
    console.error("error ", error);
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CommunityConstants.CREATE_COMMUNITY_FAILURE));
    toast.error(message);
  }
};

export const joinCommunity = (id, name) => async (dispatch) => {
  try {
    dispatch(actionType(CommunityConstants.JOIN_COMMUNITY_REQUEST));
    const data = await CommunityService.join(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(CommunityConstants.JOIN_COMMUNITY_SUCCESS, data.data));
    // toast.success(`You have successfully joined ${name}`);
    dispatch(fetchCommunity(id));
    dispatch(fetchCommunityMembers(id));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CommunityConstants.JOIN_COMMUNITY_FAILURE));
    toast.error(message);
  }
};

export const leaveCommunity = (id) => async (dispatch) => {
  try {
    dispatch(actionType(CommunityConstants.LEAVE_COMMUNITY_REQUEST));
    const data = await CommunityService.leave(id);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(actionType(CommunityConstants.LEAVE_COMMUNITY_SUCCESS, data.data));
    // toast.success(`You have left the community successfully`);
    dispatch(fetchCommunity(id));
    dispatch(fetchCommunityMembers(id));
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CommunityConstants.LEAVE_COMMUNITY_FAILURE));
    toast.error(message);
  }
};

export const getApproval = (payload) => async (dispatch) => {
  const { id, name, action } = payload;
  try {
    dispatch(
      actionType(CommunityConstants.COMMUNITY_APPROVAL_REQUEST, {
        loading: true,
        id,
      })
    );
    const data = await CommunityService.approveOrDisapprove(payload);
    if (data === undefined || data.status !== 200) {
      throw data;
    }
    dispatch(
      actionType(CommunityConstants.COMMUNITY_APPROVAL_SUCCESS, {
        loading: false,
        id,
      })
    );
    toast.success(`${name} ${action} successfully.`);
  } catch (error) {
    let message = ErrorHelper.getApiErrorMessage(error);
    dispatch(actionType(CommunityConstants.COMMUNITY_APPROVAL_FAILURE), {
      loading: false,
      id,
    });
    toast.error(message);
  }
};
